// PromptBlock — renders a user's message in the thread.
//
// Replaces the pre-redesign purple pill: no bubble, no fill. A full-width
// line with a YOU eyebrow and a left rule, so the coach reply (which is the
// actual content) carries the visual weight.

import { useI18n } from '../i18n/index.js';
import styles from './Coach.module.css';

export interface PromptBlockProps {
  text: string;
  /** Optional eyebrow suffix (e.g., "· MON 29 SEP" for a history thread). */
  eyebrowSuffix?: string;
}

export function PromptBlock({ text, eyebrowSuffix }: PromptBlockProps) {
  const { t } = useI18n();
  const eyebrow = eyebrowSuffix ? `${t('coach.you')} · ${eyebrowSuffix}` : t('coach.you');
  return (
    <div className={styles.you}>
      <div className={styles.youEyebrow}>{eyebrow}</div>
      <div className={styles.youText}>{text}</div>
    </div>
  );
}
